import { render, staticRenderFns } from "./richTextView.vue?vue&type=template&id=45cb2c84&scoped=true&"
import script from "./richTextView.vue?vue&type=script&lang=js&"
export * from "./richTextView.vue?vue&type=script&lang=js&"
import style0 from "./richTextView.vue?vue&type=style&index=0&id=45cb2c84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb2c84",
  null
  
)

export default component.exports